import { useCallback } from 'react';
import { useAccessControlStore } from '../stores/accessControlStore';
import { isRouteAllowed } from './routeAccess';

/**
 * Hook reativo para checar acesso a um href, usando a lista de
 * platformModules liberada pelo backend. Reage a mudanças no store.
 */
export const useRouteAccess = () => {
  const platformModules = useAccessControlStore((state) => state.platformModules);

  const canAccess = useCallback(
    (href: string) => isRouteAllowed(href, platformModules),
    [platformModules]
  );

  return { canAccess, platformModules };
};
